export default __webpack_public_path__ + "static/media/help.b9ea92a2.svg";